(() => {
  const protectionText = /add\s+accident\s+protection/i;
  const protectionModuleText = /shipping\s+protection|checkout\s+without\s+shipping\s+protection/i;
  const protectionModuleSelector = [
    '[class*="protection" i]',
    '[id*="protection" i]',
    '[class*="insurance" i]',
    '[id*="insurance" i]',
    '[class*="xcotton" i]',
    '[id*="xcotton" i]',
    '[class*="guard" i]',
    '[id*="guard" i]',
  ].join(',');

  const getLineIdentity = (line, fallbackIndex) => {
    const quantity = line.querySelector(
      '[data-quantity-line-key], [data-quantity-variant-id], input[id^="Drawer-quantity-"]',
    );

    return (
      quantity?.dataset.quantityLineKey ||
      quantity?.dataset.quantityVariantId ||
      line.dataset.key ||
      line.id ||
      `line-${fallbackIndex}`
    );
  };

  const findControlRoot = (button, line) => {
    let current = button;

    while (current.parentElement && current.parentElement !== line) {
      const parent = current.parentElement;
      const marker = `${parent.id || ''} ${parent.className || ''}`;
      if (/insurance|protection|xcotton|guard/i.test(marker)) current = parent;
      if (parent.matches('.cart-item__details, .cart-item__quantity, td')) break;
      current = parent.children.length <= 2 && protectionText.test(parent.textContent || '') ? parent : current;
      if (current !== parent) break;
    }

    return current;
  };

  const capture = (root) => {
    if (!root) return [];

    const lineControls = Array.from(root.querySelectorAll('.cart-item')).flatMap((line, index) => {
      const button = Array.from(line.querySelectorAll('button, a, [role="button"]')).find((candidate) =>
        protectionText.test(candidate.textContent || ''),
      );
      if (!button) return [];

      let control = findControlRoot(button, line);
      const area = control.closest('.cart-item__details, .cart-item__quantity');
      let areaName = null;
      let childIndex = null;

      if (area) {
        while (control.parentElement && control.parentElement !== area) control = control.parentElement;
        areaName = area.classList.contains('cart-item__details') ? 'details' : 'quantity';
        childIndex = Array.from(area.children).indexOf(control);
      }

      return [{ key: getLineIdentity(line, index), index, control, areaName, childIndex }];
    });

    const moduleCandidates = Array.from(root.querySelectorAll(protectionModuleSelector)).filter(
      (candidate) =>
        !candidate.closest('.cart-item') &&
        protectionModuleText.test(candidate.textContent || '') &&
        !candidate.parentElement?.closest(protectionModuleSelector),
    );
    const checkoutArea = root.querySelector('.drawer__footer .cart__ctas');
    const footerModules = moduleCandidates.map((control) => ({
      type: 'footer',
      control,
      checkoutPosition:
        checkoutArea && (control.compareDocumentPosition(checkoutArea) & Node.DOCUMENT_POSITION_FOLLOWING)
          ? 'before'
          : 'after',
    }));

    const secondaryCheckout = Array.from(root.querySelectorAll('a, button')).find(
      (candidate) => !candidate.closest('.cart-item') && protectionModuleText.test(candidate.textContent || ''),
    );
    if (secondaryCheckout && !footerModules.some(({ control }) => control.contains(secondaryCheckout))) {
      footerModules.push({
        type: 'footer',
        control: secondaryCheckout,
        checkoutPosition:
          checkoutArea &&
          (secondaryCheckout.compareDocumentPosition(checkoutArea) & Node.DOCUMENT_POSITION_FOLLOWING)
            ? 'before'
            : 'after',
      });
    }

    return [...lineControls.map((entry) => ({ ...entry, type: 'line' })), ...footerModules];
  };

  const restore = (root, preserved = []) => {
    if (!root || !preserved.length) return;
    const lines = Array.from(root.querySelectorAll('.cart-item'));

    preserved.forEach(({ type, key, index, control, areaName, childIndex, checkoutPosition }) => {
      if (type === 'footer') {
        const drawerFooter = root.querySelector('.drawer__footer');
        if (!drawerFooter || root.contains(control)) return;
        const matchingModuleExists = Array.from(drawerFooter.querySelectorAll(protectionModuleSelector)).some(
          (candidate) => protectionModuleText.test(candidate.textContent || ''),
        );
        if (matchingModuleExists) return;
        const checkoutArea = drawerFooter.querySelector('.cart__ctas');
        if (!checkoutArea) {
          drawerFooter.appendChild(control);
        } else if (checkoutPosition === 'after') {
          checkoutArea.insertAdjacentElement('afterend', control);
        } else {
          drawerFooter.insertBefore(control, checkoutArea);
        }
        return;
      }

      const line =
        lines.find((candidate, candidateIndex) => getLineIdentity(candidate, candidateIndex) === key) || lines[index];
      if (!line || line.contains(control)) return;

      const alreadyRendered = Array.from(line.querySelectorAll('button, a, [role="button"]')).some((candidate) =>
        protectionText.test(candidate.textContent || ''),
      );
      if (alreadyRendered) return;

      const destination =
        (areaName === 'details' && line.querySelector('.cart-item__details')) ||
        (areaName === 'quantity' && line.querySelector('.cart-item__quantity')) ||
        line.querySelector('.cart-item__details') ||
        line.querySelector('.cart-item__quantity') ||
        line;
      const anchor = Number.isInteger(childIndex) ? destination.children[childIndex] : null;
      destination.insertBefore(control, anchor || null);
    });
  };

  window.CrownwellCartStability = { capture, restore };
})();
